/**
* Content Media Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Media Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import lottie from 'lottie-web';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'content-media-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.content-media-banner .pause-video' ).on( 'click', function() {
        $( this ).toggleClass( 'is-paused' );
        if ( $( this ).hasClass( 'is-paused' ) ) {
          $( this ).closest( '.relative' ).find( '.loop-video' )[0].pause();
        } else {
          $( this ).closest( '.relative' ).find( '.loop-video' )[0].play();
        }
      } );

      $( '.content-media-banner' ).each( function( key, val ) {
        const height = $( this ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 50%',
            end: 'bottom 50%',
            scrub: 0,
            onEnter: ( x, y, z ) => {
              $( this ).addClass( 'is-loaded' );
            },
          },
        } );

        $( val ).find( '.animated-icon-wrapper' ).each( function( animKey, anim ) {
          lottie.loadAnimation( {
            container: anim, // the dom element that will contain the animation
            renderer: 'svg',
            name: $( anim ).attr( 'data-name' ),
            loop: true,
            autoplay: true,
            path: $( anim ).attr( 'data-animation' ), // the path to the animation json
          } );
          lottie.setSpeed( 0.75 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-media-banner', COMPONENT );
} )( app );
